import { useEffect, type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import FanchaHeader from "./FanchaHeader";
import FanchaFooter from "./FanchaFooter";

interface FanchaLayoutProps {
  children: ReactNode;
}

export default function FanchaLayout({ children }: FanchaLayoutProps) {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      const el = document.getElementById(id);
      if (el) {
        const t = window.setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
        return () => window.clearTimeout(t);
      }
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname, location.hash]);

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <FanchaHeader />
      <main className="flex-1">{children}</main>
      <FanchaFooter />
    </div>
  );
}